var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isActive)?_c('div',[_c('buildings',{on:{"stepCompleted":function($event){_vm.stepCompleted = $event}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }